import React from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

import Broadcasts from "./broadcasts/Broadcasts.jsx";
import ContentItems from "./contentItems/ContentItems.jsx";
import Folders from "./folders/Folders.jsx";

const messages = {
  folders: {
    id: "modules.ArriVideo.components.Dashboard.folders",
    description: "Folders label",
    defaultMessage: "Folders",
  },
  broadcasts: {
    id: "modules.ArriVideo.components.Dashboard.broadcasts",
    description: "Broadcasts label",
    defaultMessage: "Broadcasts",
  },
};

const Dashboard = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey = location.hash || "#broadcasts";

  const handleSelect = (key) => {
    navigate(key);
  };

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        ArriVideo
      </Card.Header>
      <Card.Body>
        <Tabs
          activeKey={activeKey}
          onSelect={handleSelect}
          id="arrivideo-dashboard-tabs"
          className="custom-tabs"
        >
          <Tab eventKey="#folders" title={intl.formatMessage(messages.folders)}>
            <Folders />
          </Tab>
          <Tab
            eventKey="#broadcasts"
            title={intl.formatMessage(messages.broadcasts)}
          >
            <Broadcasts />
          </Tab>
          <Tab eventKey="#content" title="Content">
            <ContentItems />
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
